// @generated by protoc-gen-es v2.13.0 with parameter "target=ts"
// @generated from file plugnmeet_lti_v1.proto (package plugnmeet, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file plugnmeet_lti_v1.proto.
 */
export const file_plugnmeet_lti_v1: GenFile = /*@__PURE__*/
  fileDesc("ChZwbHVnbm1lZXRfbHRpX3YxLnByb3RvEglwbHVnbm1lZXQioAEKCUx0aUNsYWltcxIPCgd1c2VyX2lkGAEgASgJEgwKBG5hbWUYAiABKAkSEAoIaXNfYWRtaW4YAyABKAgSDwoHcm9vbV9pZBgEIAEoCRISCgpyb29tX3RpdGxlGAUgASgJEj0KFWx0aV9jdXN0b21fcGFyYW1ldGVycxgGIAEoCzIeLnBsdWdubWVldC5MdGlDdXN0b21QYXJhbWV0ZXJzIrYEChNMdGlDdXN0b21QYXJhbWV0ZXJzEh4KDXJvb21fZHVyYXRpb24YASABKARCAjABSACIAQESGAoLYWxsb3dfcG9sbHMYAiABKAhIAYgBARIiChVhbGxvd19zaGFyZWRfbm90ZV9wYWQYAyABKAhIAogBARIgChNhbGxvd19icmVha291dF9yb29tGAQgASgISAOIAQESHAoPYWxsb3dfcmVjb3JkaW5nGAUgASgISASIAQESFwoKYWxsb3dfcnRtcBgGIAEoCEgFiAEBEiUKGGFsbG93X3ZpZXdfb3RoZXJfd2ViY2FtcxgHIAEoCEgGiAEBEigKG2FsbG93X3ZpZXdfb3RoZXJfdXNlcnNfbGlzdBgIIAEoCEgHiAEBEhoKDW11dGVfb25fc3RhcnQYCSABKAhICIgBARI1ChFsdGlfY3VzdG9tX2Rlc2lnbhgKIAEoCzIaLnBsdWdubWVldC5MdGlDdXN0b21EZXNpZ25CEAoOX3Jvb21fZHVyYXRpb25CDgoMX2FsbG93X3BvbGxzQhgKFl9hbGxvd19zaGFyZWRfbm90ZV9wYWRCFgoUX2FsbG93X2JyZWFrb3V0X3Jvb21CEgoQX2FsbG93X3JlY29yZGluZ0INCgtfYWxsb3dfcnRtcEIbChlfYWxsb3dfdmlld19vdGhlcl93ZWJjYW1zQh4KHF9hbGxvd192aWV3X290aGVyX3VzZXJzX2xpc3RCEAoOX211dGVfb25fc3RhcnQizwEKD0x0aUN1c3RvbURlc2lnbhIaCg1wcmltYXJ5X2NvbG9yGAEgASgJSACIAQESHAoPc2Vjb25kYXJ5X2NvbG9yGAIgASgJSAGIAQESHQoQYmFja2dyb3VuZF9jb2xvchgDIAEoCUgCiAEBEhgKC2N1c3RvbV9sb2dvGAQgASgJSAOIAQFCEAoOX3ByaW1hcnlfY29sb3JCEgoQX3NlY29uZGFyeV9jb2xvckITChFfYmFja2dyb3VuZF9jb2xvckIOCgxfY3VzdG9tX2xvZ29CnAEKDWNvbS5wbHVnbm1lZXRCE1BsdWdubWVldEx0aVYxUHJvdG9QAVoyZ2l0aHViLmNvbS9teW5hcGFycm90L3BsdWdubWVldC1wcm90b2NvbC9wbHVnbm1lZXSiAgNQWFiqAglQbHVnbm1lZXTKAglQbHVnbm1lZXTiAhVQbHVnbm1lZXRcR1BCTWV0YWRhdGHqAglQbHVnbm1lZXRiBnByb3RvMw");

/**
 * @generated from message plugnmeet.LtiClaims
 */
export type LtiClaims = Message<"plugnmeet.LtiClaims"> & {
  /**
   * @generated from field: string user_id = 1;
   */
  userId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_admin = 3;
   */
  isAdmin: boolean;

  /**
   * @generated from field: string room_id = 4;
   */
  roomId: string;

  /**
   * @generated from field: string room_title = 5;
   */
  roomTitle: string;

  /**
   * @generated from field: plugnmeet.LtiCustomParameters lti_custom_parameters = 6;
   */
  ltiCustomParameters?: LtiCustomParameters | undefined;
};

/**
 * Describes the message plugnmeet.LtiClaims.
 * Use `create(LtiClaimsSchema)` to create a new message.
 */
export const LtiClaimsSchema: GenMessage<LtiClaims> = /*@__PURE__*/
  messageDesc(file_plugnmeet_lti_v1, 0);

/**
 * @generated from message plugnmeet.LtiCustomParameters
 */
export type LtiCustomParameters = Message<"plugnmeet.LtiCustomParameters"> & {
  /**
   * @generated from field: optional uint64 room_duration = 1 [jstype = JS_STRING];
   */
  roomDuration?: string | undefined;

  /**
   * @generated from field: optional bool allow_polls = 2;
   */
  allowPolls?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_shared_note_pad = 3;
   */
  allowSharedNotePad?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_breakout_room = 4;
   */
  allowBreakoutRoom?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_recording = 5;
   */
  allowRecording?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_rtmp = 6;
   */
  allowRtmp?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_view_other_webcams = 7;
   */
  allowViewOtherWebcams?: boolean | undefined;

  /**
   * @generated from field: optional bool allow_view_other_users_list = 8;
   */
  allowViewOtherUsersList?: boolean | undefined;

  /**
   * @generated from field: optional bool mute_on_start = 9;
   */
  muteOnStart?: boolean | undefined;

  /**
   * @generated from field: plugnmeet.LtiCustomDesign lti_custom_design = 10;
   */
  ltiCustomDesign?: LtiCustomDesign | undefined;
};

/**
 * Describes the message plugnmeet.LtiCustomParameters.
 * Use `create(LtiCustomParametersSchema)` to create a new message.
 */
export const LtiCustomParametersSchema: GenMessage<LtiCustomParameters> = /*@__PURE__*/
  messageDesc(file_plugnmeet_lti_v1, 1);

/**
 * @generated from message plugnmeet.LtiCustomDesign
 */
export type LtiCustomDesign = Message<"plugnmeet.LtiCustomDesign"> & {
  /**
   * @generated from field: optional string primary_color = 1;
   */
  primaryColor?: string | undefined;

  /**
   * @generated from field: optional string secondary_color = 2;
   */
  secondaryColor?: string | undefined;

  /**
   * @generated from field: optional string background_color = 3;
   */
  backgroundColor?: string | undefined;

  /**
   * @generated from field: optional string custom_logo = 4;
   */
  customLogo?: string | undefined;
};

/**
 * Describes the message plugnmeet.LtiCustomDesign.
 * Use `create(LtiCustomDesignSchema)` to create a new message.
 */
export const LtiCustomDesignSchema: GenMessage<LtiCustomDesign> = /*@__PURE__*/
  messageDesc(file_plugnmeet_lti_v1, 2);

